module.exports = __webpack_public_path__ + "img/approved-tick.e0ee830c.svg";